enum ViewType {
  Details = 'Details',
  PDF = 'PDF',
}

export default ViewType;
